import { formatInTimeZone } from 'date-fns-tz'
import styles from './PreviousShiftLabel.module.scss'
import tableStyles from '../../CombinedLogs.module.scss'
import { Row, Table } from '@tanstack/react-table'
import { Log } from '@/types/logs'
import { useAuthStore } from '@/store/auth-store'
import { useDateStore } from '@/components/DateInput'
import { isToday } from 'date-fns'

export const PreviousShiftLabel = ({
    table,
    row,
    isSeparator = false,
}: {
    table: Table<Log>
    row: Row<Log>
    isSeparator?: boolean
}) => {
    const { date } = useDateStore()
    const { previousDutyCode } = useAuthStore()

    const lastShiftLogs = table
        .getFilteredRowModel()
        .rows.map((row) => row.original)
        .filter((log) => log.userShift)
        .filter((log) => previousDutyCode === log.userShift.dutyCode)

    const firstLogOfLastShift = lastShiftLogs[0]
    const lastLogOfLastShift = lastShiftLogs.at(-1)

    const selectedSortType = table.getState().sorting
    const isTimeFilterSelected = selectedSortType.length === 0 || selectedSortType[0].id === 'time'
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    if (!isToday(date)) return null
    if (!isTimeFilterSelected) return null
    if (lastShiftLogs.length === 0) return null
    if (!firstLogOfLastShift.userShift.dutyFrom || !firstLogOfLastShift.userShift.dutyTo) return null

    if (isSeparator)
        return lastLogOfLastShift?.id === row.original.id ? <tr className={tableStyles.bodySeparator}></tr> : null

    if (!firstLogOfLastShift || firstLogOfLastShift.id !== row.original.id) return null

    return (
        <tr className={styles.shiftSeparator}>
            <td colSpan={16}>
                {firstLogOfLastShift.userShift.authorName}, Duty: {firstLogOfLastShift.userShift.dutyCode},{' '}
                {formatInTimeZone(firstLogOfLastShift.userShift.dutyFrom, timezone, 'HH:mm')} -{' '}
                {formatInTimeZone(firstLogOfLastShift.userShift.dutyTo, timezone, 'HH:mm')}
            </td>
        </tr>
    )
}
